import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { FloorplansClient, type OverviewView } from '@/features/storage/FloorplansClient';
import { rememberOverviewView } from '@/features/storage/storage.api';
import { ownerSearch } from '@/features/storage/OwnerFilter';

interface OverviewSearch {
  /** List or map — in the URL, so "‹ Plattegronden" comes back to the same view. */
  view?: 'map';
  /** The owner chosen for all of Opslag, by its slug (owners, step 7). */
  owner?: string;
}

export const Route = createFileRoute('/_shell/storage/floorplans/')({
  validateSearch: (search: Record<string, unknown>): OverviewSearch => ({
    view: search['view'] === 'map' ? 'map' : undefined,
    owner: ownerSearch(search),
  }),
  component: OverviewRoute,
});

function OverviewRoute() {
  const { view, owner } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onOwner = useCallback(
    (next: string | undefined) =>
      void navigate({ search: (prev) => ({ ...prev, owner: next }), replace: true }),
    [navigate],
  );
  return (
    <FloorplansClient
      view={view ?? 'list'}
      onView={(next: OverviewView) => {
        rememberOverviewView(next);
        void navigate({
          search: (prev) => ({ ...prev, view: next === 'map' ? 'map' : undefined }),
          replace: true,
        });
      }}
      owner={owner}
      onOwner={onOwner}
    />
  );
}
